export const SUPERADMINMANAGEOS = 'SUPERADMINMANAGEOS'
export const SUPERADMINMANAGEOSTYPE = 'SUPERADMINMANAGEOSTYPE'